export default "__VITE_ASSET__Tn_N14uV__"